// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React from 'react'

export const Delete = ({ width = 16, height = 16, style = {}, fill }) => (
  <svg
    className='svg-icon'
    viewBox='0 0 1024 1024'
    version='1.1'
    style={style}
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
  >
    <path
      fill={fill}
      d='M864 192h-192V128c0-32-32-64-64-64h-192c-32 0-64 32-64 64v64H160C128 192 96 224 96 256v64c0 32 32 64 64 64v512c0 32 32 64 64 64h576c32 0 64-32 64-64V384c32 0 64-32 64-64V256c0-32-32-64-64-64z m-64 704H224V384h576v512zM416 128h192v64h-192V128z m448 192H160V256h704v64z m-512 128h64v384h-64V448z m128 0h64v384h-64V448z m128 0h64v384h-64V448z'
    />
  </svg>
)
